<template>
  <div :class="[cardSize, 'bg-white rounded-lg shadow p-4 my-2']" ref="card">
    <!-- Encabezado y botones -->
    <div class="flex justify-between items-center mb-2">
      <h3 class="text-base md:text-lg font-semibold text-gray-800 text-center w-full">
        PEDIDO #{{ content.id }}: {{ content.marca }}
      </h3>
      <div class="flex gap-2 ml-2 shrink-0">
        <button @click="downloadContent(content)"
          class="text-sky-500 hover:text-sky-700 focus:outline-none"
          v-tooltip="{ content: 'Descargar', triggers: ['hover'] }">
          <i class="bx bx-download"></i>
        </button>
        <button @click="deleteItem(content)"
          class="text-red-500 hover:text-red-700 focus:outline-none"
          v-tooltip="'Eliminar de pedido'">
          <i class="bx bx-trash"></i>
        </button>
      </div>
    </div>

    <hr class="border-slate-200 mb-3">

    <!-- GRID DE DATOS -->
    <div class="grid grid-cols-2 2xl:grid-cols-5 gap-y-2 gap-x-4 cursor-pointer"
      @click="$functions.modals.openPedidoModal(content.id, $axios, $apiRoute)">
      <!-- Col 1 -->
      <div>
        <div class="text-xs text-slate-500">Fecha</div>
        <div class="font-medium text-sm">{{ content.fecha ?? 'N/A' }}</div>
        <div class="text-xs text-slate-500 mt-1">Enviado</div>
        <div class="font-medium text-sm">{{ content.fecenviado ?? 'N/A' }}</div>
      </div>

      <!-- Col 2 -->
      <div>
        <div class="text-xs text-slate-500">Estado</div>
        <div class="font-medium text-sm">{{ content.estado ?? 'N/A' }}</div>
        <div class="text-xs text-slate-500 mt-1">Origen</div>
        <div class="font-medium text-sm">{{ content.origen ?? 'N/A' }}</div>
      </div>

      <!-- Col 3 -->
      <div>
        <div class="text-xs text-slate-500">Marca</div>
        <div class="font-medium text-sm">{{ content.marca ?? 'N/A' }}</div>
        <div class="text-xs text-slate-500 mt-1">Usuario</div>
        <div class="font-medium text-sm">{{ content.usuario ?? 'N/A' }}</div>
      </div>

      <!-- Col 4 -->
      <div>
        <div class="text-xs text-slate-500">Renglones</div>
        <div class="font-medium text-sm">{{ content.total_ren ?? 'N/A' }}</div>
        <div class="text-xs text-slate-500 mt-1">Unidades</div>
        <div class="font-medium text-sm">{{ content.total_unds ?? 'N/A' }}</div>
      </div>

      <!-- Col 5 -->
      <div>
        <div class="text-xs text-slate-500">Total (VES)</div>
        <div class="font-bold text-base">{{ formatCurrency(parseFloat(content?.total_pedido), 'es-VE', "VES") ?? 'N/A' }}</div>
        <div class="text-xs text-slate-500 mt-1">Total (USD)</div>
        <div class="font-bold text-base">{{ formatCurrency(parseFloat(content?.total_pedido_ext), 'en-US', "USD") ?? 'N/A' }}</div>
      </div>
    </div>
  </div>
</template>


<script>
import Swal from 'sweetalert2';
import { mapState, mapActions } from 'vuex';

export default {
	name: "CardPedidoList",
	props: [
		"title",
		"content",
		"cardClass",
		"cardSize",
		"headerClass",
		"index",
		"lastIndex",
	],
	components: {

	},
	computed: {
		...mapState("orders", ["cartItems", "cartItemsQuantity"]),
		...mapState("pedidos", ["buttonLoading"]),
	},
	data() {

		return {
			animate: false,
			imageSrc: `${this.$imgProdUrl}/${this.content.barra}.jpg`,
			altImageSrc: `${this.$imgProdUrl}/noimagen.jpg`,
			showModal: false,
			inputValue: this.content?.quantity,
			inputValue2: this.content?.discountItem,
			moleculaBs: this.$functions.prices.getPrecioMolecula(this.content)[0],
			molecula: this.$functions.prices.getPrecioMolecula(this.content)[1],
			localContent: { ...this.content },
		};
	},

	methods: {
		...mapActions("orders", ["fetchCartItemsQuantity", 'updateCartItemQuantity']),
		...mapActions('pedidos', ['getPedidos']),
		showSweetAlert(obj) {
			Swal.fire(obj);
		},
		closeModal() {
			this.showModal = false;
		},
		formatCurrency(value, locale, currency) {
			if (value) {
				return value.toLocaleString(locale, {
					style: "currency",
					currency: currency,
				});
			}
		},

		deleteItem(item) {
			// Show a confirmation dialog using SweetAlert
			Swal.fire({
				title: `¿Esta seguro de borrar el pedido #${item.id}: ${item.marca}?`,
				text: "Esta acción no se puede deshacer.",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#3085d6",
				confirmButtonText: "Eliminar",
				cancelButtonText: "Cancelar",
				focusConfirm: false,
				reverseButtons: true,
				customClass: {
					confirmButton: "custom-confirm-button",
				},
			}).then((result) => {
				if (result.isConfirmed) {
					// Dispatch the removeFromCart action to remove the product from the cart in the Vuex store
					this.$store.dispatch('pedidos/deletePedido', {
						id: item.id,
						axios: this.$axios,
						apiRoute: this.$apiRoute
					}).then(() => {

						this.getPedidos({
							axios: this.$axios,
							apiRoute: this.$apiRoute,
							showPedidos: true
						});
						// Once the cart items quantity is updated, commit a mutation to update it in the state
						this.$store.commit('orders/updateCartItemsQuantity', this.cartItemsQuantity - item.total_ren);

						const Toast = Swal.mixin({
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3000,
							timerProgressBar: true,
							didOpen: (toast) => {
								toast.addEventListener('mouseenter', Swal.stopTimer)
								toast.addEventListener('mouseleave', Swal.resumeTimer)
							}
						})

						Toast.fire({
							icon: 'success',
							title: 'El pedido ha sido eliminado.'
						})


					})
				}
			});
		},


		downloadContent(item) {
			const swalWithInput = Swal.mixin({
				input: 'select',
				confirmButtonText: 'Descargar <i class="fa fa-arrow-right"></i>',
				showCancelButton: true,
				inputValidator: (value) => {
					return new Promise((resolve) => {
						if (!value) {
							resolve('Debes seleccionar una opción');
						}

						resolve();
					});
				},
				inputOptions: {
					'pdf': 'PDF',
					'excel': 'Excel',
					'zip': 'PDF y Excel'
				},
			});

			swalWithInput.fire({
				title: `Opciones de descarga del pedido #${item.id}: ${item.marca}`,
				iconHtml: '<i class="bx bx-file"></i>',
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				cancelButtonText: 'Cancelar',
				focusConfirm: false,
				reverseButtons: true,
				showLoaderOnConfirm: true,
				customClass: {
					confirmButton: 'custom-confirm-button',
					icon: 'custom-icon-class',
					title: 'custom-title-class'
				},
				inputPlaceholder: 'Selecciona una opción',
				showCancelButton: true,
				preConfirm: (value) => {
					return this.pickTemplateAndDownload(item, value);
				}
			});

		},

		async fetchAvailableTemplates(format) {
			try {
				const token = localStorage.getItem('authToken');
				const response = await this.$axios.get(`${this.$apiRoute}/pedido/export-templates/available`, {
					headers: { Authorization: `Bearer ${token}` },
					params: { format },
				});
				return response.data?.data ?? [];
			} catch (error) {
				return [];
			}
		},

		async pickTemplateAndDownload(item, type) {
			// zip combina PDF + Excel, no tiene una plantilla propia -- se descarga directo
			const templates = type === 'zip' ? [] : await this.fetchAvailableTemplates(type);

			let templateId = null;

			if (templates.length > 0) {
				const options = { '': 'Formato original (sin plantilla)' };
				templates.forEach((t) => { options[t.id] = t.name; });

				const templateResult = await Swal.fire({
					title: 'Selecciona una plantilla',
					input: 'select',
					inputOptions: options,
					inputValue: templates.find((t) => t.is_default)?.id ?? '',
					showCancelButton: true,
					reverseButtons: true,
					confirmButtonText: 'Continuar',
					cancelButtonText: 'Cancelar',
				});

				if (!templateResult.isConfirmed) {
					return Promise.reject('Cancelado');
				}

				templateId = templateResult.value || null;
			}

			const searchParams = { type };
			if (templateId) {
				searchParams.template_id = templateId;
			}

			try {
				await this.$store.dispatch('pedidos/downloadPedido', {
					item,
					axios: this.$axios,
					apiRoute: this.$apiRoute,
					searchParams,
				});
			} catch (error) {
				return Promise.reject('Error al descargar el pedido');
			}
		}

	},
	watch: {
		"content.barra": function () {
			this.imageSrc = `${this.$imgProdUrl}/${this.content.barra}.jpg`;
			this.altImageSrc = `${this.$imgProdUrl}/noimagen.jpg`;
		},
		"content.quantity": function () {
			this.inputValue = this.content?.quantity;
		},
		showModal(newVal) {
			console.log("showModal changed:", newVal);
		},
	},
	mounted() {
		(this.imageSrc = `${this.$imgProdUrl}/${this.content.barra}.jpg`),
			(this.altImageSrc = `${this.$imgProdUrl}/noimagen.jpg`);
	},
};
</script>

<style>
.product-image {
	transition: transform 0.3s;
}

.product-image:hover {
	transform: scale(1.2);
	z-index: 99;
	box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.6);
	position: relative;
}
</style>
